import axios from "axios";
import {watch} from 'vue'
import getApiUrl from './api'
import { ElLoading, ElMessage } from 'element-plus'
import { useDemoStore } from '../../pinia/index'
import { convertNumericStrings } from "../convertNumericStrings";
const store = useDemoStore()

let baseURL = getApiUrl();
const service = axios.create({
  baseURL,
  timeout: 30000, // 请求超时时间(因为需要调试后台,所以设置得比较大)
});

watch(() => store.server, (newVal) => {
  service.defaults.baseURL = getApiUrl()
})


let loadObj;
// request拦截器
service.interceptors.request.use(
  (config) => {
    if (!loadObj) {
      // loadObj = ElLoading.service({
      //   lock: true,
      //   text: "Loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
    }
    // 请求头添加token
     config.headers["Accept-Language"] =store.lang;
     config.headers["codeKey"] = store.codeKey;
    //  config.headers["token"] =store.token;
    // config.headers['token'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiIiLCJhdWQiOiIiLCJpYXQiOjE2NzIwMTU0NTMsIm5iZiI6MTY3MjAxNTU1MywiZXhwIjoxNjc0NjA3NDUzLCJpZCI6NDAwMDY5fQ.c5d6r-BfWSBNjmueWQURqNW4rwbemIAtzIZflcj0_eI';
    return config;
  },
  (error) => {
    // setTimeout(() => {
    //   loadObj.close();
    // }, 300);
    return Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    // setTimeout(() => {
    //   loadObj.close();
    // }, 300);

    // const res = response.data;
    const res = convertNumericStrings(response.data);
    // console.log(res)
    if (res.Status == 0) {
      return res;
    } else if(res.Status == 1){
      ElMessage(res.Message);
      return res;
    }else if(res.Status == 1000){
      location.reload(); 
      return res
    }else{
      return res
    }
  },
  (error) => {
    // setTimeout(() => {
    //   loadObj.close();
    // }, 300);
    ElMessage(error.message);
    return Promise.reject(error.message);
  }
);
export default service;
